//= require webfontloader/webfontloader.js
import WebFont from 'webfontloader'

document.addEventListener("DOMContentLoaded", function() {
    if (document.querySelector(".lazy-image")) {
        console.log("Loading images in")
        // const isMobile = window.innerWidth < 768 ? true : false;
        const isMobile = false;
        const lazyImages = document.querySelectorAll("img.lazy-image");
        
        if ("IntersectionObserver" in window) {
            let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        let lazyImage = entry.target;
                        lazyImage.src = isMobile ? lazyImage.dataset["src-mob"] : lazyImage.dataset.src;
                        lazyImage.classList.remove("lazy-image");
                        lazyImageObserver.unobserve(lazyImage);
                    }
                });
            });
            
            lazyImages.forEach(function(lazyImage) {
                lazyImageObserver.observe(lazyImage);
            });
        } else {
            lazyImages.forEach(lazyImage => lazyImage.src = lazyImage.dataset.src);
        }
    } else {
        console.warn("Lazy images not found")
    }


    /// Web Font Loader

    WebFont.load({
        google: {
          families: ['Barlow Semi Condensed:300,400,500,600,700', 'Barlow:300,400,500,600,700']
        }
      });
});   



 